import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

// Returns the current user's 6-char share_code, lazily generated server-side
// the first time it's needed. Returns null while loading or if the user isn't
// authenticated yet.
//
// Consumers should fall back to the literal "share" string in the URL when
// null is returned, so links never break even if the RPC fails.
export function useShareCode() {
  const { user } = useAuth();
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { setCode(null); return; }
    let cancelled = false;
    setLoading(true);
    supabase.rpc('ensure_share_code').then(({ data, error }) => {
      if (cancelled) return;
      if (error) {
        console.error('[share-code] ensure_share_code failed:', error.message);
        setCode(null);
      } else {
        setCode(typeof data === 'string' ? data : null);
      }
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, [user?.id]);

  return { code, loading };
}
